import React, {useContext, useEffect, useState} from "react";
import Section from "./section/Section";
import s from "./style.module.css";
import {HiMenu} from "react-icons/hi";
import {useLocation, useNavigate,} from "../../../../node_modules/react-router-dom/dist/index";
import {ActivatedNameContext} from "../../contexts/ActivatedNameContext";

export default function Menu() {
    const location = useLocation();
    const navigate = useNavigate();

    const menuItems = [
        {name: "Accueil", path: "/accueil"},
        {name: "Formations & Expériences", path: "/experiences"},
        {name: "Compétences", path: "/competences"},
        {name: "Contact", path: "/contact"},
    ];

    const getInitialActivatedName = () => {
        const currentPath =
            location.pathname === "/" ? "/accueil" : location.pathname;
        const menuItem = menuItems.find((item) => item.path === currentPath);
        console.log(currentPath);

        return menuItem ? menuItem.name : "";
    };

    const {activatedName, setActivatedName} = useContext(ActivatedNameContext);

    useEffect(() => {
        setActivatedName(getInitialActivatedName());
        // eslint-disable-next-line
    }, []);

    function isSelected(item) {
        return activatedName === item.name;
    }

    function setActivatedNameAndNavigate(item) {
        setActivatedName(item.name);
        navigate(item.path);
    }

    const [isLitleScreen, setIsMobile] = useState(window.innerWidth < 994);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 994);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    // Close the menu by clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                isMenuOpen &&
                !event.target.closest(`.${s.menuItems}`) &&
                !event.target.closest(`.${s.iconMenu}`)
            ) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [isMenuOpen]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <>
            {isLitleScreen ? (
                <>
                    <div className={s.iconMenuContainer}>
                        <HiMenu className={s.iconMenu} onClick={toggleMenu}/>
                        <div className={`${s.menuLitleScreen} ${isMenuOpen ? s.show : ""}`}>
                            {menuItems.map((item) => (
                                <a
                                    key={item.name}
                                    href={item.path}
                                    onClick={() => setIsMenuOpen(false)}
                                >
                                    {item.name}
                                </a>
                            ))}
                        </div>
                    </div>
                </>
            ) : (
                <div className={s.menu}>
                    {menuItems.map((item) => (
                        <Section
                            key={item.name}
                            item={item}
                            isSelected={isSelected(item)}
                            setActivatedNameAndNavigate={setActivatedNameAndNavigate}
                        />
                    ))}
                </div>
            )}
        </>
    );
}
